import { Button } from "antd";

const ApplicationColumns = ({ goToUpdatePage }) => [
  {
    title: "Kimlik",
    dataIndex: "id",
    key: "id",
    sorter: true,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Uygulama Tipi",
    dataIndex: "app",
    key: "app",
  },
  {
    title: "iOS Uygulaması",
    dataIndex: "iosLink",
    key: "iosLink",
    render: (value) =>
      value ? (
        <Button type="link" href={value} target="_blank">
          App Store
        </Button>
      ) : (
        "Kayıtlı Link Yok"
      ),
  },
  {
    title: "Android Uygulaması",
    dataIndex: "androidLink",
    key: "androidLink",
    render: (value) =>
      value ? (
        <Button type="link" href={value} target="_blank">
          Play Store
        </Button>
      ) : (
        "-"
      ),
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    fixed: "right",
    render: (_, record) => (
      <div style={{ display: "flex" }}>
        <Button type="link" onClick={() => goToUpdatePage({ record })}>
          Güncelle
        </Button>
        <Button type="link" danger>
          Sil
        </Button>
      </div>
    ),
  },
];

export { ApplicationColumns };
